module.exports = __webpack_public_path__ + "img/madhurima.94a89dbb.jpg";